import { ProductHeading, Spacing } from '@issuu/silkscreen';
import React from 'react';
const Headline = props => (React.createElement(Spacing, { bottom: 2, top: 3 },
    React.createElement(ProductHeading, { level: 2, step: "1" }, props.children)));
export default Headline;
//# sourceMappingURL=Headline.js.map